import { Component, HostBinding, Input, OnInit } from "@angular/core";

import { WebComponentInitializerService } from "../shared/web-component-initializer.service";
import { ForsyningPaaAdresseComponent } from "../../../../common/src/lib/forsyning-paa-adresse/forsyning-paa-adresse.component";

@Component({
    selector: "dffedb-forsyning-paa-adresse",
    templateUrl: "./dffedb-forsyning-paa-adresse.component.html",
    styleUrls: ["./dffedb-forsyning-paa-adresse.component.scss"],
    imports: [ForsyningPaaAdresseComponent]
})
export class DffedbForsyningPaaAdresseComponent implements OnInit {
    @HostBinding("class.mat-app-background") public classMatAppBackground = true;
    @Input() public nodeId: number;

    constructor(private readonly webComponentInitializer: WebComponentInitializerService) {}

    public ngOnInit(): void {
        this.webComponentInitializer.init(this.nodeId);
    }
}
